"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdpOverflow = function AdpOverflow(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M102.4 823.616c-25.6 0-51.2 10.24-71.68 30.72S0 895.296 0 926.016c0 25.6 10.24 51.2 30.72 71.68s40.96 30.72 71.68 30.72 51.2-10.24 71.68-30.72 30.72-40.96 30.72-71.68c0-30.72-10.24-51.2-30.72-71.68s-46.08-30.72-71.68-30.72zm0-614.4c25.6 0 51.2-10.24 71.68-30.72s30.72-40.96 30.72-71.68c0-25.6-10.24-51.2-30.72-71.68S128 4.416 102.4 4.416s-51.2 10.24-71.68 30.72S0 76.096 0 106.816c0 30.72 10.24 51.2 30.72 71.68s40.96 30.72 71.68 30.72zm0 204.8c-30.72 0-51.2 10.24-71.68 30.72S0 490.816 0 516.416s10.24 51.2 30.72 71.68 40.96 30.72 71.68 30.72 51.2-10.24 71.68-30.72 30.72-46.08 30.72-71.68-10.24-51.2-30.72-71.68-46.08-30.72-71.68-30.72z"
  })));
};

AdpOverflow.defaultProps = {
  viewBox: '0 0 205 1043.776',
  height: '1em',
  width: '0.1964em'
};
AdpOverflow.displayName = 'AdpOverflow';
var _default = AdpOverflow;
exports.default = _default;